@if (show) {
  <div class="iframe-wrapper">
    @if (url | safeResourceUrl; as safeUrl) {
      <iframe #iFrame id="dcp-iframe" title="{{ title }}" [src]="safeUrl"></iframe>
    }
    <!-- DCP Configurator -->
  </div>
}
